/**
 * Sanitization des entrées pour le stockage et l'affichage.
 * Supprime les balises HTML, scripts, URI javascript:, event handlers.
 */

export function sanitizeText(input) {
  if (typeof input !== "string") return "";
  return input
    .replace(/<[^>]*>/g, "")
    .replace(/javascript:/gi, "")
    .replace(/on\w+\s*=/gi, "")
    // ASCII C0 hors tabulation / LF / CR — échappements \u pour la lisibilité ; ESLint no-control-regex sinon.
    // eslint-disable-next-line no-control-regex
    .replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/g, "")
    .trim()
    .slice(0, 1000);
}

export function sanitizeClient(client) {
  if (!client || typeof client !== "object") return client;
  return {
    ...client,
    name: sanitizeText(client.name),
    objective: sanitizeText(client.objective),
    constraints: sanitizeText(client.constraints || ""),
    preferences: sanitizeText(client.preferences || ""),
    disponibilites: sanitizeText(client.disponibilites || ""),
  };
}
